import React from 'react'
import './card-sale.scss';

import Redirect from '../../../shared/components/atoms/redirect/redirect';
import Button from '../../../shared/components/atoms/button/button';
import iconLocation from '../../../shared/assets/images/icons/icon-location.svg';
import numberCurrency from '../../../shared/utils/numberCurrency';
import SliderGalery from '../slider-galery/slider-galery';
import siteUrl from '../../../shared/utils/siteUrl';
import { utilGtm } from '../../../shared/utils/utilGtm';


const CardSale = props => {
    const { sale } = props;
    const {
        nombre,
        valorInmueble,
        direccionDelInmueble,
        area,
        metrosCuadradosConstruidos,
        imagenesPrevias,
        tipoDeBien,
        tagDeCategoria,
        cilindradaDelMotor,
        color,
        kilometraje,
        modelo,
        tipoTransmision,
        tipoVehiculo,
        cantidadDeHabitaciones,
        numeroDeBanos,
        slug
    } = sale;

    const handleRedirectCar = slug => {
        window.location.href = siteUrl + '/bienes-en-venta/' + slug + '/formulario/'
    }

    const tagVehiculo = 'Vehículos';

    const contentInmueble = () => {
        return (
            <div className="a-card-sale-content-inmueble">
                <div className="a-card-sale-content-inmueble-container">
                    <p className="a-card-sale-direccion">
                        <img src={iconLocation} alt="icon location" />
                        <span>{direccionDelInmueble}</span>
                    </p>
                    {
                        tagDeCategoria && tagDeCategoria.nombreTab.toLocaleLowerCase().trim() === 'lote' ?
                            <p className="a-card-sale-text">{`Área: ${area}`}</p> :
                            <div>
                                <p className="a-card-sale-text">
                                    { (area ) ? `Área: ${area}` : ''} 
                                    { ( area && metrosCuadradosConstruidos ) ? ' / ' : '' }
                                    { (metrosCuadradosConstruidos) ? `Construcción: ${metrosCuadradosConstruidos}m2` : '' }    
                                </p>
                                <p className="a-card-sale-text">
                                    {cantidadDeHabitaciones ? `${cantidadDeHabitaciones} habitaciones` : ''}
                                    {cantidadDeHabitaciones && numeroDeBanos ? ' / ' : ''}
                                    {numeroDeBanos ? `${numeroDeBanos} baños` : ''}
                                </p>
                            </div>
                    }
                </div>
                <Redirect gtm={ utilGtm( "gtmBienesClic", tipoDeBien + " " +  slug ) } url={`bienes-en-venta/${slug}/`} className="button">
                    CONOCE MÁS
                </Redirect>
            </div>
        )
    }

    const contentCar = () => {
        return (
            <div className="a-card-sale-content-car">
                <div className="a-card-sale-content-car-container">

                    {
                        modelo &&
                        <div className="a-card-sale-text">
                            <b>Modelo:</b><br />
                            {modelo}
                        </div>
                    }
                    {
                        color &&
                        <div className="a-card-sale-text">
                            <b>Color:</b><br />
                            {color}
                        </div>
                    }
                    {
                        kilometraje &&
                        <div className="a-card-sale-text">
                            <b>Kilometraje:</b><br />
                            {kilometraje} km
                        </div>
                    }
                    {
                        cilindradaDelMotor &&
                        <div className="a-card-sale-text">
                            <b>Motor:</b><br />
                            {cilindradaDelMotor}
                        </div>
                    }
                    {
                        tipoVehiculo &&
                        <div className="a-card-sale-text">
                            <b>Tipo:</b><br />
                            {tipoVehiculo.nombreTab}
                        </div>
                    }
                    {
                        tipoTransmision &&
                        <div className="a-card-sale-text">
                            <b>Transmisión:</b><br />
                            {tipoTransmision}
                        </div>
                    }
                </div>
                <Button
                    gtm={ utilGtm( "gtmBienesClicContactar", slug ) }
                    title="CONTACTAR"
                    onClick={() => handleRedirectCar(slug)}
                />
            </div>
        )
    }

    return (
        <div className="a-card-sale ">
            <div className="a-card-sale-slider">
                <SliderGalery images={imagenesPrevias} maxShow={3} title={ nombre } />
            </div>
            <div className="a-card-sale-container">
                {
                    (tagDeCategoria && tipoDeBien !== tagVehiculo ) &&
                    <div className="a-card-sale-label-container">
                        <label className={"a-card-sale-label " + tagDeCategoria.colorEtiquetas}>{tagDeCategoria.nombreTab}</label>
                    </div>
                }
                {
                    (tipoVehiculo && tipoDeBien === tagVehiculo ) &&
                    <div className="a-card-sale-label-container">
                        <label className={"a-card-sale-label " + tipoVehiculo.colorEtiquetas}>{tipoVehiculo.nombreTab}</label>
                    </div>
                }
                <h3 className="a-card-sale-title custom-h h6">{nombre}</h3>
                <p className="a-card-sale-valor custom-h h4">
                    {
                        numberCurrency(valorInmueble)
                    }
                </p>
                {
                    tipoDeBien === tagVehiculo ?
                        contentCar() :
                        contentInmueble()
                }
            </div>
        </div>
    )
}

export default CardSale
